// Copyright ©️ 2026 eVolve MEP, LLC

import { Fragment } from 'react';

import type { TaskType } from '@evolvemep/api-ts';
import { Divider, Loader, Stack, Collapse, Text } from '@mantine/core';

import { isNotNil } from 'helpers/isNotNil';
import { TriggerOnVisible } from 'hooks/useOnScreen';
import { TaskTypeListItem } from 'modules/Shop/ShopSetup/WorkCellSetup/ShopSetupPage/TaskTypes/TaskTypeListItem';

type Props = {
  loading: boolean;
  groupTasks: TaskType[];
  entireCount: number | undefined;
  onTaskSelect: (task: TaskType) => void;
  nothingFoundText?: string;
  fetchNextPage?: () => void;
  hideDelete?: boolean;
  isWorkCellMapping?: boolean;
};

export const TaskTypeList = ({
  groupTasks,
  onTaskSelect,
  loading,
  entireCount,
  nothingFoundText = 'No tasks in group.',
  fetchNextPage,
  hideDelete,
  isWorkCellMapping,
}: Props) => (
  <Stack gap={0} mih={94}>
    <Collapse expanded={groupTasks.length > 0}>
      {groupTasks.map((t, index) => (
        <Fragment key={t.taskTypeId}>
          <TaskTypeListItem
            key={t.taskTypeId}
            task={t}
            onTaskSelect={onTaskSelect}
            hideDelete={hideDelete}
            isWorkCellMapping={isWorkCellMapping}
          />
          {index + 1 !== groupTasks.length && <Divider />}
        </Fragment>
      ))}
    </Collapse>
    <Stack flex={1} align="center" justify="center">
      {entireCount === 0 && !loading && (
        <Text fz="sm" c="dimmed">
          {nothingFoundText}
        </Text>
      )}
      {isNotNil(fetchNextPage) ? (
        <TriggerOnVisible onVisible={fetchNextPage} loading={loading} />
      ) : (
        loading && <Loader type="dots" />
      )}
    </Stack>
  </Stack>
);
